import React from "react";
import { useTranslation } from "react-i18next";

export default function Refund() {
    const { t } = useTranslation();

    return (
        <div className="container py-5 mb-5" style={{ minHeight: "60vh" }}>
            <div className="card border-0 shadow-sm p-4 p-md-5">
                <h2 className="fw-bold text-primary mb-4">
                    <i className="bi bi-arrow-counterclockwise me-2"></i>
                    {t("footer_pol_refund")}
                </h2>
                <div className="text-muted lh-lg">
                    <h5 className="fw-bold text-dark mt-4">{t("refund_1_title")}</h5>
                    <p>{t("refund_1_desc")}</p>

                    <h5 className="fw-bold text-dark mt-4">{t("refund_2_title")}</h5>
                    <ul className="mb-4">
                        <li>{t("refund_2_li1")}</li>
                        <li>{t("refund_2_li2")}</li>
                        <li>{t("refund_2_li3")}</li>
                    </ul>

                    <h5 className="fw-bold text-dark mt-4">{t("refund_3_title")}</h5>
                    <p>{t("refund_3_desc")}</p>

                    <h5 className="fw-bold text-dark mt-4">{t("refund_4_title")}</h5>
                    <p>{t("refund_4_desc")}</p>
                </div>
            </div>
        </div>
    );
}